/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
   window.addEventListener('load', function () {

    if (window.location.href.includes('#stockists')) {
     setTimeout(function () {
       // console.log(document.querySelector(window.location.hash))
       document.querySelector('html,body').animate({
         scrollTop: document.querySelector('#stockists').offset().top
       });
     }, 2000);
    }
  }, false);

  /**
 * Gets the option index that is different between `variant` in `previousVariant`.
 *
 * @param {object} variant
 * @param {object} previousVariant
 * @returns {1 | 2 | 3}
 */
 const getChangedOptionIndex = (variant, previousVariant) => {
   for (let i = 0; i < variant.options.length; i++) {
     if (variant.options[i] !== previousVariant.options[i]) {
       return i;
     }
   }
   return undefined; // return undefined if no option has changed
 };

 if (document.querySelector('.ProductForm__Variants')) {

   /**x
    * Find a variant via its options.
    *
    * @param {object[]} variants
    * @param {{ option1?: string, option2?: string, option3?: string }} options
    * @returns {object | undefined}
    */
   const findVariantByOptions = (variants, options) => {
     return variants.find((variant) =>
       (!options.option1 || variant.option1 === options.option1) &&
       (!options.option2 || variant.option2 === options.option2) &&
       (!options.option3 || variant.option3 === options.option3)
     );
   };

   const { product } = JSON.parse(document.querySelector('script[data-product-json]').innerHTML);

   document.addEventListener('variant:changed', (event) => {
     if (!event.detail.variant) return;

     const { variant, previousVariant } = event.detail;
     const changedOptionIndex = getChangedOptionIndex(variant, previousVariant);

     if (changedOptionIndex === undefined) return;

     const optionInputEls = document.querySelectorAll('input[name^="option-"]');

     optionInputEls.forEach((optionInputEl) => {
       const optionIndex = Number(optionInputEl.name.split('-')[1]);

       if (optionIndex !== changedOptionIndex) {
         const optionsToCheck = {
           [`option${changedOptionIndex + 1}`]: variant.options[changedOptionIndex],
           [`option${optionIndex + 1}`]: optionInputEl.value,
         };

         const foundVariant = findVariantByOptions(product.variants, optionsToCheck);

         if (!foundVariant || !foundVariant.available) {
           optionInputEl.nextElementSibling.classList.add('opt-sold-out');
         } else {
           optionInputEl.nextElementSibling.classList.remove('opt-sold-out');
         }
       }
     });
   });
 }

// Adding state to Labels// Adding state to Labels
function updateHasContentClass(container) {
  Array.from(container.children).forEach(el => {
    // Check if the element contains any visible content
    const hasVisibleContent = /\S/.test(el.textContent);  // \S matches any non-whitespace character

    // If the element contains visible content (anything other than just whitespace), add 'has-content'
    if (hasVisibleContent || el.querySelector('.ProductItem__Label')) {
      el.classList.add('has-content');
      el.classList.remove('no-content');
    } else {
      // If the element contains only whitespace (or is empty), remove 'has-content' and add 'no-content'

      el.classList.remove('has-content');
      el.classList.add('no-content');
    }
  });
}


// Initialize MutationObserver
function observeLabelContainer(container) {
  const observer = new MutationObserver(() => {
    updateHasContentClass(container);
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
    characterData: true // Ensure text content changes are observed
  });

  // Initial update
  updateHasContentClass(container);
}

// Apply observer to all .ProductItems__LabelContainer elements
function applyObserverToAllContainers() {
  document.querySelectorAll('.ProductItems__LabelContainer').forEach(container => {
    observeLabelContainer(container);
  });

  // Monitor for new .ProductItems__LabelContainer elements added dynamically
  const globalObserver = new MutationObserver(mutationsList => {
    mutationsList.forEach(mutation => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.matches('.ProductItems__LabelContainer')) {
            observeLabelContainer(node);
          }
        });
      }
    });
  });

  // Observe the body for added containers
  globalObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Start observing right away
applyObserverToAllContainers();

// Wrapping pushState and replaceState to detect changes
(function() {
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  // Detect changes when pushState is used
  history.pushState = function(state, title, url) {
    const result = originalPushState.apply(history, arguments);
    window.dispatchEvent(new Event('urlchange')); // Custom event when URL changes
    return result;
  };

  // Detect changes when replaceState is used
  history.replaceState = function(state, title, url) {
    const result = originalReplaceState.apply(history, arguments);
    window.dispatchEvent(new Event('urlchange')); // Custom event when URL changes
    return result;
  };
})();


// Listen for URL changes and rerun applyObserverToAllContainers()
window.addEventListener('urlchange', () => {
  // console.log('updates');

  // Set a delay (e.g., 500ms) before running the observer
  setTimeout(() => {
    applyObserverToAllContainers();
  }, 1000); // Delay of 500 milliseconds (adjust as needed)
});



function normalizeQBColor(value) {
  return (value || '').toString().trim().toLowerCase();
}

function showQBSizeList(selectedColorInput, product) {
  if (selectedColorInput) {
    const selectedColor = normalizeQBColor(selectedColorInput.value);
    product.querySelectorAll('.quick-buy-simple .HorizontalList__Item').forEach(item => {
      if (normalizeQBColor(item.dataset.color) === selectedColor) {
        item.style.display = 'inline-block';
      } else {
        item.style.display = 'none';
      }
    });
  }
}

function showListButton(listButton){
  listButton.classList.add('hidden');
  const quickBuyList = listButton.parentElement.querySelector('.quick-buy-list');
  quickBuyList.classList.remove('hidden');
  quickBuyList.classList.add('is-active');
}

function syncQuickBuyVariantFromSwatch(productItem, swatchInput) {
  if (!productItem || !swatchInput) return;

  const variantId = swatchInput.getAttribute('data-variant-id');
  if (!variantId) return;

  // Color-only quick buy: keep hidden input + button in sync with selected swatch
  productItem.querySelectorAll('.quick-buy-color .quick-buy-variant').forEach(function(input) {
    input.value = variantId;
  });
  productItem.querySelectorAll('.quick-buy-color [data-action="add-to-cart"], .quick-buy-color .quick-buy-button').forEach(function(button) {
    button.setAttribute('data-variant-id', variantId);
  });
}

function getBuyItWithVariantId(button, form, productItem) {
  // 1) Size buttons carry the exact variant id
  if (button && button.getAttribute('data-variant-id')) {
    return parseInt(button.getAttribute('data-variant-id'), 10);
  }

  // 2) Color-only: prefer the currently checked swatch
  const checkedSwatch = productItem && productItem.querySelector('.ProductItem__ColorSwatchItem input:checked');
  if (checkedSwatch && checkedSwatch.getAttribute('data-variant-id')) {
    return parseInt(checkedSwatch.getAttribute('data-variant-id'), 10);
  }

  // 3) Fallback to the form input
  const idInput = form && form.querySelector('[name="id"]');
  return idInput ? parseInt(idInput.value, 10) : NaN;
}

function getBuyItWithPayload(button, form, productItem) {
  const variantId = getBuyItWithVariantId(button, form, productItem);
  const quantityInput = form.querySelector('[name="quantity"]');
  const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

  if (!variantId) {
    return null;
  }

  // Keep form input aligned so any other listeners see the same id
  const idInput = form.querySelector('[name="id"]');
  if (idInput) {
    idInput.value = String(variantId);
  }
  if (button) {
    button.setAttribute('data-variant-id', String(variantId));
  }

  const payload = {
    id: variantId,
    quantity: quantity
  };

  const properties = {};
  form.querySelectorAll('[name^="properties["]').forEach(function(el) {
    const match = el.name && el.name.match(/^properties\[(.+)\]$/);
    if (match && el.value) {
      properties[match[1]] = el.value;
    }
  });

  if (Object.keys(properties).length) {
    payload.properties = properties;
  }

  return payload;
}

// Buy-it-with on PDP: capture-phase handler so the main ProductVariants add-to-cart never runs
document.addEventListener('click', function(event) {
  const target = event.target.nodeType === Node.TEXT_NODE ? event.target.parentElement : event.target;
  if (!target || !target.closest) return;

  const button = target.closest('.buy-it-with [data-action="add-to-cart"]');
  if (!button || button.disabled || button.classList.contains('disabled')) {
    return;
  }

  const form = button.closest('form[action*="/cart/add"]');
  const productItem = button.closest('.ProductItem');
  if (!form) {
    return;
  }

  const payload = getBuyItWithPayload(button, form, productItem);
  if (!payload) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();

  button.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  fetch((window.routes.cartAddUrl || '/cart/add') + '.js', {
    body: JSON.stringify(payload),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(function(response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));

    if (response.ok) {
      button.removeAttribute('disabled');
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          quantity: payload.quantity
        }
      }));
      return;
    }

    response.json().then(function(content) {
      var description = content && content.description ? content.description : 'An error occurred';
      if (typeof description === 'object' && description !== null) {
        description = Object.values(description).flat().join('. ') || 'An error occurred';
      }

      var errorMessageElement = document.createElement('span');
      errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
      errorMessageElement.innerHTML = description;
      button.removeAttribute('disabled');
      button.insertAdjacentElement('afterend', errorMessageElement);
      setTimeout(function() {
        errorMessageElement.remove();
      }, 5000);
    });
  }).catch(function() {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    button.removeAttribute('disabled');
  });
}, true);


document.addEventListener('DOMContentLoaded', function() {
  // Ensure that all the ProductItems are processed
  document.querySelectorAll('.ProductItem').forEach(product => {
    const selectedColorInput = product.querySelector('.ProductItem__ColorSwatchItem input:checked');
    showQBSizeList(selectedColorInput, product);
    syncQuickBuyVariantFromSwatch(product, selectedColorInput);

    product.addEventListener('change', event => {
      if (event.target.matches('.ProductItem__ColorSwatchItem input')) {
        const selectedColor = normalizeQBColor(event.target.value);
        product.querySelectorAll('.quick-buy-simple .HorizontalList__Item').forEach(item => {
          if (normalizeQBColor(item.dataset.color) === selectedColor) {
            item.style.display = 'inline-block';
          } else {
            item.style.display = 'none';
          }
        });
        syncQuickBuyVariantFromSwatch(product, event.target);
      }
    });
  });

  // Quick Buy button functionality
  document.querySelectorAll('.list-button').forEach(listButton => {
    listButton.addEventListener('click', event => {
      showListButton(listButton)
    });
  });

  // Plus Button functionality
  document.querySelectorAll('.plusButton').forEach(function(button) {
    button.addEventListener('click', handleQBPlusClick);
    button.addEventListener('touchend', handleQBPlusClick); // For mobile devices
  });

  function serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf('[');

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};
      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === '' || formElement.disabled) {
        continue;
      }

      if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = extend(hash, stringKeys);
      }
    }

    return hash;
  }

  // Extend function to merge objects (similar to your Form.extend method)
  function extend(target, source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        if (target[key] && typeof target[key] === 'object' && typeof source[key] === 'object') {
          target[key] = extend(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    }
    return target;
  }

  function handleQBPlusClick(event) {
    event.preventDefault();  // Prevents default action for touchend or click
    var targetDiv = document.querySelector('.quick-buy-mobile');
    if (targetDiv) {
      targetDiv.innerHTML = '';
      // var sourceDiv = this.nextElementSibling; // Get the sibling div

      var productItem = event.target.closest(".ProductItem")

      if (productItem) {
        var buttonsInSourceDiv = productItem.querySelectorAll('.Button--light');
        buttonsInSourceDiv.forEach(function(button) {
          button.classList.remove('Button--light');  // Remove the light button class
          button.classList.add('Button--dark');  // Add the dark button class
          button.classList.add('qb-mobile-add-button');  // Add the dark button class
        });

        var clonedContent = productItem.cloneNode(true);
        targetDiv.appendChild(clonedContent);
        targetDiv.classList.add('is-active');

        let swatchParent = targetDiv.querySelector(".ProductItem__ColorSwatchList");
        let swatchTarget = targetDiv.querySelector(".qb-swatches");

        if (swatchParent) {
          swatchTarget.appendChild(swatchParent)
          var swatches = targetDiv.querySelectorAll('.ProductItem__ColorSwatchItem');
          if (swatches) {
            swatches.forEach(function(swatch) {
              if (swatch) {
                swatch.addEventListener('click', event => {

                    swatches.forEach(function(swatch) {
                        swatch.querySelector("input").checked = false;
                    });

                    var swatchInput = swatch.querySelector("input")
                    if (swatchInput) {
                      swatchInput.checked = true;
                    }

                    var swatchValue = swatchInput?.getAttribute("value") || "";
                    var swatchVariant = swatchInput?.getAttribute("data-variant-id") || "";
                    var variantAvailable = swatchInput?.getAttribute('data-variant-available');
                    var variantInventory = swatchInput?.getAttribute('data-variant-inventory');
                    var variantCompareAtPrice = swatchInput?.getAttribute('data-variant-compare-at-price');
                    var variantPrice = swatchInput?.getAttribute('data-variant-price');
                    var variantPreOrder = swatchInput?.getAttribute('data-variant-preorder');
                    var variantRestock = swatchInput?.getAttribute('data-variant-restock');

                    targetDiv.querySelector(".qb-variant").innerHTML = swatchValue;
                    targetDiv.querySelector(".quick-buy-variant").value = swatchVariant;

                    // Change the button if pre-order, sale, sold output
                    const quickBuyButton = targetDiv.querySelector('.quick-buy-button')
                    var quickBuyButtonMessage = targetDiv.querySelector('.quick-buy-button > .add-to-cart');


                    var productPreOrder = targetDiv.getAttribute('data-product-preorder');
                    var productRestock = targetDiv.getAttribute('data-product-restock');

                    showQBSizeList(swatchInput, targetDiv)

                    if (variantAvailable == "true") {
                      targetDiv.querySelector('.quick-buy-simple').classList.remove('hidden')
                      quickBuyButton.classList.remove('hidden')
                      quickBuyButton.classList.remove('disabled')

                      if (productPreOrder || variantPreOrder) {
                        const preOrderMessage = quickBuyButtonMessage.getAttribute('pre-order-message');

                        if (preOrderMessage) {
                          quickBuyButtonMessage.textContent = preOrderMessage;
                        } else {
                          console.warn('pre-order-message attribute not found.');
                        }
                      } else {
                        if (quickBuyButtonMessage) {
                          const addToCartMessage = quickBuyButtonMessage.getAttribute('add-to-cart-message');
                          quickBuyButtonMessage.textContent = addToCartMessage;
                        } else {
                          console.warn('add-to-cart-message attribute not found.');
                        }
                      }

                      var productFormPreOrderProperty = targetDiv.querySelector('.ProductForm__PreOrder textarea');
                      if (productFormPreOrderProperty) {
                        if (productPreOrder || variantPreOrder) {
                          productFormPreOrderProperty.innerHTML = productPreOrder || variantPreOrder;
                          productFormPreOrderProperty.name = 'properties[Estimated Ship Date]';
                        } else {
                          productFormPreOrderProperty.innerHTML = '';
                          productFormPreOrderProperty.name = '';
                        }
                      }

                      var productFormRestockProperty = targetDiv.querySelector('.ProductForm__Restock textarea');
                      if (productFormRestockProperty) {
                        if (productRestock || variantRestock) {
                          productFormRestockProperty.innerHTML = productRestock || variantRestock;
                          productFormRestockProperty.name = 'properties[Estimated Restock Date]';
                        } else {
                          productFormRestockProperty.innerHTML = '';
                          productFormRestockProperty.name = '';
                        }
                      }
                    } else {
                      // console.log('unavailable')
                      const soldOutMessage = quickBuyButtonMessage.getAttribute('sold-out-message');
                      if (soldOutMessage) {
                        quickBuyButton.classList.remove('hidden')
                        quickBuyButton.classList.add('disabled');
                        quickBuyButtonMessage.textContent = soldOutMessage;
                      } else {
                        targetDiv.querySelector('.quick-buy-simple').classList.add('hidden')
                      }
                    }

                    // Need to account for size options
                    targetDiv.querySelectorAll('.list-button').forEach(listButton => {
                      showListButton(listButton)
                    });

                })
              }
            })
          }
        }

        var buttonstargetDiv = targetDiv.querySelectorAll('.qb-mobile-add-button');
        buttonstargetDiv.forEach(function(button) {
          if (button) {
            button.addEventListener('click', event => {
              event.preventDefault();  // Prevents default action for touchend or click

              var addToCartButton = button // First, we switch the status of the button
              addToCartButton.setAttribute('disabled', 'disabled');
              document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

              var formElement = button.closest('form[action*="/cart/add"]');

              fetch("".concat(window.routes.cartAddUrl, ".js"), {
                body: JSON.stringify(serialize(formElement)),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

                }
              }).then(function (response) {
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                var quantityElement = formElement.querySelector('[name="quantity"]');

                if (response.ok) {
                  addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
                  targetDiv.classList.remove('is-active');

                  _this4.element.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                      variant: _this4.currentVariant,
                      quantity: quantityElement ? parseInt(quantityElement.value) : 1
                    }
                  }));
                } else {
                  response.json().then(function (content) {
                    var errorMessageElement = document.createElement('span');
                    errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                    errorMessageElement.innerHTML = content['description'];
                    addToCartButton.removeAttribute('disabled');
                    addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                    setTimeout(function () {
                      errorMessageElement.remove();
                    }, 2500);
                  });
                }
              });
              event.preventDefault();  // Prevents default action for touchend or click
              // window.Rebuy.SmartCart.show()
            });
          }
        })

        const closeButton = document.querySelector('.quick-buy-mobile .close-quick-buy-mobile-details');
        if (closeButton) {
          closeButton.addEventListener('click', event => {
            const quickBuyMobile = document.querySelector('.quick-buy-mobile');
            if (quickBuyMobile) {
              quickBuyMobile.classList.remove('is-active');
            }
          });
        }

      }

      // if (sourceDiv) {
      //   var buttonsInSourceDiv = sourceDiv.querySelectorAll('.Button--light');
      //   buttonsInSourceDiv.forEach(function(button) {
      //     button.classList.remove('Button--light');  // Remove the light button class
      //     button.classList.add('Button--dark');  // Add the dark button class
      //     button.classList.add('qb-mobile-add-button');  // Add the dark button class
      //   });
      //
      //
      //   var clonedContent = sourceDiv.cloneNode(true);
      //   targetDiv.appendChild(clonedContent);
      //   targetDiv.classList.add('is-active');
      //
      //   var buttonstargetDiv = targetDiv.querySelectorAll('.qb-mobile-add-button');
      //   buttonstargetDiv.forEach(function(button) {
      //     if (button) {
      //       button.addEventListener('click', event => {
      //         event.preventDefault();  // Prevents default action for touchend or click
      //
      //         var addToCartButton = button // First, we switch the status of the button
      //         addToCartButton.setAttribute('disabled', 'disabled');
      //         document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
      //
      //         var formElement = button.closest('form[action*="/cart/add"]');
      //
      //         fetch("".concat(window.routes.cartAddUrl, ".js"), {
      //           body: JSON.stringify(serialize(formElement)),
      //           credentials: 'same-origin',
      //           method: 'POST',
      //           headers: {
      //             'Content-Type': 'application/json',
      //             'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      //
      //           }
      //         }).then(function (response) {
      //           document.dispatchEvent(new CustomEvent('theme:loading:end'));
      //           var quantityElement = formElement.querySelector('[name="quantity"]');
      //
      //           if (response.ok) {
      //             addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
      //             targetDiv.classList.remove('is-active');
      //
      //             _this4.element.dispatchEvent(new CustomEvent('product:added', {
      //               bubbles: true,
      //               detail: {
      //                 variant: _this4.currentVariant,
      //                 quantity: quantityElement ? parseInt(quantityElement.value) : 1
      //               }
      //             }));
      //           } else {
      //             response.json().then(function (content) {
      //               var errorMessageElement = document.createElement('span');
      //               errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
      //               errorMessageElement.innerHTML = content['description'];
      //               addToCartButton.removeAttribute('disabled');
      //               addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
      //               setTimeout(function () {
      //                 errorMessageElement.remove();
      //               }, 2500);
      //             });
      //           }
      //         });
      //         event.preventDefault();  // Prevents default action for touchend or click
      //         // window.Rebuy.SmartCart.show()
      //       });
      //     }
      //   })
      //
      //   const closeButton = document.querySelector('.quick-buy-mobile .close-quick-buy-mobile-details');
      //   if (closeButton) {
      //     closeButton.addEventListener('click', event => {
      //       const quickBuyMobile = document.querySelector('.quick-buy-mobile');
      //       if (quickBuyMobile) {
      //         quickBuyMobile.classList.remove('is-active');
      //       }
      //     });
      //   }
      // }
    }
  }

  // Quick buy swatches click
});

/**
 * iOS changes the layout width by a pixel or two when the browser toolbar
 * shows and hides. Flickity treats that as a resize and the product gallery
 * height jumps. Ignore those tiny width changes.
 */
(function () {
  if (!window.Flickity) return;

  var originalResize = window.Flickity.prototype.resize;
  var lastWidth = window.innerWidth;

  window.Flickity.prototype.resize = function () {
    if (Math.abs(window.innerWidth - lastWidth) < 2 && this.maxCellHeight > 0) {
      return;
    }

    lastWidth = window.innerWidth;
    return originalResize.apply(this, arguments);
  };
})();

/**
 * Mobile product gallery thumbnails. One tab stop for the strip; arrow keys
 * move between photos. Swiping the main image keeps the active thumbnail in view.
 */
(function () {
  function scrollThumbIntoView(strip, thumb) {
    var left = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
    strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }

  function initMobileThumbnails(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.matches && root.matches('[data-section-type="product"]')
      ? [root]
      : root.querySelectorAll('[data-section-type="product"]');

    sections.forEach(function (section) {
      var strip = section.querySelector('.Product__MobileThumbnails');
      var slideshow = section.querySelector('.Product__Slideshow');

      if (!strip || !slideshow || !window.Flickity || strip.hasAttribute('data-mobile-thumbs-ready')) {
        return;
      }

      var flkty = window.Flickity.data(slideshow);
      if (!flkty) return;

      strip.setAttribute('data-mobile-thumbs-ready', 'true');

      var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.Product__MobileThumbnail'));
      var currentIndex = flkty.selectedIndex;

      function setSelected(index, shouldScroll) {
        thumbs.forEach(function (thumb, i) {
          var selected = i === index;
          thumb.classList.toggle('is-selected', selected);
          thumb.tabIndex = selected ? 0 : -1;

          if (selected) {
            thumb.setAttribute('aria-current', 'true');
            if (shouldScroll) scrollThumbIntoView(strip, thumb);
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      setSelected(currentIndex, false);

      strip.addEventListener('click', function (event) {
        var thumb = event.target.closest('.Product__MobileThumbnail');
        if (!thumb || !strip.contains(thumb)) return;

        var index = parseInt(thumb.getAttribute('data-index'), 10);
        if (index === flkty.selectedIndex) return;

        flkty.select(index);
      });

      strip.addEventListener('keydown', function (event) {
        var index = flkty.selectedIndex;
        var nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = Math.min(thumbs.length - 1, index + 1);
        else if (event.key === 'ArrowLeft') nextIndex = Math.max(0, index - 1);
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = thumbs.length - 1;
        else return;

        event.preventDefault();
        if (nextIndex === index) return;

        flkty.select(nextIndex);
        thumbs[nextIndex].focus();
      });

      flkty.on('select', function () {
        if (flkty.selectedIndex === currentIndex) return;
        currentIndex = flkty.selectedIndex;
        setSelected(currentIndex, true);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMobileThumbnails(document);
    });
  } else {
    initMobileThumbnails(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initMobileThumbnails(event.target);
  });
})();

/**
 * Product videos autoplay muted when their slide is showing. They stay paused
 * when Reduce motion is on, unless the shopper presses the play button.
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function motionAllowed() {
    return !reduceMotion.matches;
  }

  function buttonFor(video) {
    var slide = video.closest('.Product__SlideItem');
    return slide && slide.querySelector('[data-action="toggle-product-video"]');
  }

  function setButtonState(video) {
    var button = buttonFor(video);
    if (!button) return;

    var label = button.querySelector('[data-product-video-label]');
    var playing = !video.paused;
    button.setAttribute('aria-pressed', playing ? 'false' : 'true');

    if (label) {
      label.textContent = button.getAttribute(playing ? 'data-label-pause' : 'data-label-play');
    }
  }

  function playVideo(video) {
    if (!motionAllowed() || video.dataset.userPaused === 'true') return;

    video.muted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var start = function () {
      if (!motionAllowed() || video.dataset.userPaused === 'true') return;

      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    };

    if (video.readyState >= 2) start();
    else video.addEventListener('canplay', start, { once: true });
  }

  function syncProductVideos(section) {
    var slideshow = section.querySelector('.Product__Slideshow');
    if (!slideshow || !window.Flickity || slideshow.hasAttribute('data-video-autoplay-ready')) return;

    var flkty = window.Flickity.data(slideshow);
    if (!flkty) return;

    slideshow.setAttribute('data-video-autoplay-ready', 'true');

    slideshow.querySelectorAll('video').forEach(function (video) {
      video.addEventListener('play', function () {
        if (video.dataset.userPaused === 'true' || (!motionAllowed() && video.dataset.userStarted !== 'true')) {
          video.pause();
          return;
        }

        setButtonState(video);
      });
      video.addEventListener('pause', function () {
        setButtonState(video);
      });
    });

    slideshow.addEventListener('click', function (event) {
      var button = event.target.closest('[data-action="toggle-product-video"]');
      if (!button || !slideshow.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();

      var video = button.closest('.Product__SlideItem').querySelector('video');
      if (!video) return;

      if (video.paused) {
        delete video.dataset.userPaused;
        video.dataset.userStarted = 'true';
        video.muted = true;
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
      } else {
        video.dataset.userPaused = 'true';
        delete video.dataset.userStarted;
        video.pause();
      }
    });

    var sync = function () {
      var cell = flkty.selectedCell && flkty.selectedCell.element;

      slideshow.querySelectorAll('video').forEach(function (video) {
        if (cell && cell.contains(video)) playVideo(video);
        else video.pause();

        setButtonState(video);
      });
    };

    flkty.on('settle', sync);
    reduceMotion.addEventListener('change', function () {
      if (!motionAllowed()) {
        slideshow.querySelectorAll('video').forEach(function (video) {
          delete video.dataset.userStarted;
          video.pause();
        });
      }

      sync();
    });
    sync();
  }

  function init(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var sections = root.matches && root.matches('[data-section-type="product"]')
      ? [root]
      : root.querySelectorAll('[data-section-type="product"]');

    sections.forEach(syncProductVideos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
